import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const PortalLayout: React.FC = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="portal-layout">
            {/* Simple Header — no staff sidebar */}
            <header className="portal-header navbar navbar-light bg-white border-bottom px-3">
                <span className="navbar-brand mb-0 h4">
                    <i className="fas fa-hospital-user me-2"></i>
                    Mi Portal
                </span>

                <nav className="portal-nav d-flex align-items-center gap-2">
                    <NavLink
                        to="/portal/me"
                        className={({ isActive }) =>
                            `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`
                        }
                    >
                        <i className="fas fa-user me-1"></i> Perfil
                    </NavLink>
                    <NavLink
                        to="/portal/appointments"
                        className={({ isActive }) =>
                            `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`
                        }
                    >
                        <i className="fas fa-calendar-alt me-1"></i> Mis Citas
                    </NavLink>
                    <NavLink
                        to="/portal/history"
                        className={({ isActive }) =>
                            `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`
                        }
                    >
                        <i className="fas fa-history me-1"></i> Mi Historial
                    </NavLink>
                    <NavLink
                        to="/portal/book-appointment"
                        className={({ isActive }) =>
                            `btn btn-sm ${isActive ? 'btn-primary' : 'btn-outline-primary'}`
                        }
                    >
                        <i className="fas fa-calendar-plus me-1"></i> Agendar
                    </NavLink>

                    <span className="text-muted small ms-3">
                        {user?.name}
                    </span>

                    <button className="btn btn-sm btn-outline-danger ms-2" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt"></i>
                    </button>
                </nav>
            </header>

            {/* Page Content */}
            <main className="portal-content container py-4">
                <Outlet />
            </main>
        </div>
    );
};

export default PortalLayout;
